import api from './api';

const communityService = {
    // Obtener todas
    getAll: async () => {
        const response = await api.get('/communities');
        return response.data;
    },

    // Obtener una
    getById: async (id) => {
        const response = await api.get(`/communities/${id}`);
        return response.data;
    },

    // Crear
    create: async (data) => {
        const response = await api.post('/communities', data);
        return response.data;
    },

    // Actualizar
    update: async (id, data) => {
        const response = await api.put(`/communities/${id}`, data);
        return response.data;
    },

    // Eliminar
    delete: async (id) => {
        const response = await api.delete(`/communities/${id}`);
        return response.data;
    },
};

export default communityService;
